<template>
  <div class="m-b-20 attr table-first-style" style="margin-top: 20px">
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left">
        <i class="el-icon-star-on" style="margin-left:32px;margin-right:0;"></i>
        <span class="order-list-search-span">常用属性</span>
      </el-col>
      <el-col :span="20">
        <el-button type="primary" class="add-btn btn-right" @click="addAttr">添加属性</el-button>
      </el-col>
    </el-row>
    <el-table
      ref="multipleTable"
      :data="normal"
      v-loading="loading"
      class="customer-procuct-table">
      <el-table-column
        prop="name"
        label="属性名称">
      </el-table-column>
      <el-table-column
        label="属性分值">
        <template slot-scope="scope">
          <div v-if="scope.row.identity === 'stage_id' || scope.row.identity === 'is_vip' || scope.row.identity === 'source_id' || scope.row.identity === 'create_time' || scope.row.identity === 'update_time'">--</div>
          <div v-else>{{ scope.row.score }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200">
        <template slot-scope="scope">
          <div class="op-link" @click="setCustomerAttribute(scope.row, 0)">
            设为非常用
          </div>
          <div class="op-link" @click="openDialog(scope.row)" v-if="scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'">
            编辑
          </div>
          <div v-if="scope.row.is_system === 0 && scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'" class="op-link" @click="removeCustomerAttribute(scope.row)">
            删除
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" style="text-align: left">
        <i class="el-icon-star-off"  style="margin-left:32px;margin-right:0;"></i>
        <span class="order-list-search-span">非常用属性</span>
      </el-col>
    </el-row>
    <el-table
      ref="multipleTable"
      :data="notNormal"
      class="customer-procuct-table">
      <el-table-column
        prop="name"
        label="属性名称">
      </el-table-column>
      <el-table-column
        label="属性分值">
        <template slot-scope="scope">
          <div v-if="scope.row.identity === 'stage_id' || scope.row.identity === 'is_vip' || scope.row.identity === 'source_id' || scope.row.identity === 'create_time' || scope.row.identity === 'update_time'">--</div>
          <div v-else>{{ scope.row.score }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        prop=""
        width="200">
         <template slot-scope="scope">
           <div class="op-link" @click="setCustomerAttribute(scope.row, 1)">
             设为常用
           </div>
           <div class="op-link" @click="openDialog(scope.row)" v-if="scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'">
             编辑
           </div>
           <div v-if="scope.row.is_system === 0 && scope.row.identity !== 'stage_id' &&scope.row.identity !== 'is_vip' && scope.row.identity !== 'source_id' && scope.row.identity !== 'create_time' && scope.row.identity !== 'update_time'" class="op-link" @click="removeCustomerAttribute(scope.row)">
             删除
           </div>
        </template>
      </el-table-column>
    </el-table>
     <!--编辑弹窗-->
    <el-dialog class="cellDialog base-dialog" title="编辑客户属性" :visible.sync="editdialog" width="530px">
      <el-form ref="editForm" :model="editForm">
        <el-form-item label="评分标准:" :label-width="addLabelWidth" prop="score">
          <el-input class="stockInput" type="text" v-model="editForm.score" auto-complete="off" placeholder="输入评分标准"></el-input>
        </el-form-item>
      </el-form>
      <div class="tabs">
        <div :class="editTabIndex === index ? 'edit-type-select' : ''" :key="index" v-for="(item, index) in editTypes" style="background: #f5f5f5;cursor: inherit">
          {{ item.name }}
        </div>
      </div>
      <el-form ref="editForm" :model="editForm" style="margin-top: 20px">
        <!--文本-->
        <div v-if="editForm.type === 'input'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" :rules="rules">
            <el-input :disabled="isSystem" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--下拉菜单-->
        <div v-if="editForm.type === 'select'" :class="editMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" :rules="rules">
            <el-input :disabled="isSystem" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px;margin-bottom: 0" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="select-item" :key="index" v-for="(item, index) in editForm.select" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="输入选项" type="text" v-model="editForm.select[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div v-if="editSystem === 0" class="removeSelectItem" @click="removeEditSelectItem(index)">删除</div>
          </div>
          <div v-if="editSystem === 0">
            <div class="addSelectItem" @click="addEditSelectItem">增加可选项</div>
          </div>
        </div>
        <!--时间-->
        <div v-if="editForm.type === 'datePicker' || editForm.type === 'dateTimePicker'">
          <el-form-item label="时间类型:" :label-width="addLabelWidth">
            <div class="date-type" style="margin-left: 50px">
              <div :key="index" :class="dateTabIndex === index ? 'dateChoose' : ''" v-for="(item, index) in timeChoose" style="cursor: inherit">
                {{ item.name }}
              </div>
            </div>
          </el-form-item>
          <div class="description-date" style="padding-left: 130px">
            <div v-if="dateTabIndex === 0">如：1977-01-01</div>
            <div v-if="dateTabIndex === 1">如：1977-01-01 23:59:59</div>
          </div>
          <el-form-item label="属性名称:" :label-width="addLabelWidth" style="padding: 20px 0 0 0">
            <el-input :disabled="isSystem" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--地址-->
        <div v-if="editForm.type === 'addressPicker'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" style="padding: 10px 0 0 0">
            <el-input class="stockInput" disabled placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--单选-->
        <div v-if="editForm.type === 'radio'" :class="editRadioMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth">
            <el-input :disabled="isSystem" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px;margin-bottom: 0" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="radio-item" :key="index" v-for="(item, index) in editForm.radio" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input :disabled="isSystem" placeholder="输入选项" class="stockInput" type="text" v-model="editForm.radio[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div v-if="editSystem === 0" class="removeSelectItem" @click="removeEditRadioItem(index)">删除</div>
          </div>
          <div v-if="editSystem === 0">
            <div class="addSelectItem" @click="addEditRadioItem">增加可选项</div>
          </div>
        </div>
        <!--复选-->
        <div v-if="editForm.type === 'checkBox'" :class="editCheckBoxMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth">
            <el-input :disabled="isSystem" class="stockInput" placeholder="输入属性名称" type="text" v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px;margin-bottom: 0" prop="identity">
            <el-input class="stockInput" disabled placeholder="输入字段标识" type="text" v-model="editForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="checkBox-item" :key="index" v-for="(item, index) in editForm.checkBox" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input :disabled="isSystem" class="stockInput" placeholder="输入选项" type="text" v-model="editForm.checkBox[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div v-if="editSystem === 0" class="removeSelectItem" @click="removeEditCheckBoxItem(index)">删除</div>
          </div>
          <div v-if="editSystem === 0">
            <div class="addSelectItem" @click="addEditCheckBoxItem">增加可选项</div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="editdialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="confirmEditAttr">确 定</el-button>
      </div>
    </el-dialog>
    <!--添加弹窗-->
    <el-dialog class="cellDialog base-dialog" title="新建客户属性" :visible.sync="adddialog" width="530px">
      <el-form ref="addForm" :model="addForm">
        <el-form-item label="评分标准:" :label-width="addLabelWidth" prop="score">
          <el-input class="stockInput" type="text" v-model="addForm.score" auto-complete="off" placeholder="输入评分标准"></el-input>
        </el-form-item>
        <el-form-item class="text-align-left new-customer-attr" label="是否常用:" :label-width="addLabelWidth">
          <template>
            <el-radio-group v-model="addForm.is_normal">
              <el-radio :label="1" style="margin-left: 0;">是</el-radio>
              <el-radio :label="0" style="margin-left: 10px;">否</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
      </el-form>
      <div class="tabs">
        <div @click="chooseType(index, item)" :class="tabIndex === index ? 'type-select' : ''" :key="index" v-for="(item, index) in types">
          {{ item.name }}
        </div>
      </div>
      <el-form ref="addForm" :model="addForm" style="margin-top: 20px" :rules="rules">
        <!--文本-->
        <div v-if="addForm.type === 'input'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" prop="name">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" prop="identity">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--下拉菜单-->
        <div v-if="addForm.type === 'select'" :class="addMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" prop="name">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px;margin-bottom: 0" prop="identity">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="select-item" :key="index" v-for="(item, index) in addForm.select" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="输入选项" type="text" v-model="addForm.select[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeSelectItem(index)">删除</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addSelectItem">增加可选项</div>
          </div>
        </div>
        <!--时间-->
        <div v-if="addForm.type === 'datePicker' || addForm.type === 'dateTimePicker'">
          <el-form-item label="时间类型:" :label-width="addLabelWidth">
            <div class="date-type">
              <div :key="index" :class="dateTabIndex === index ? 'dateChoose' : ''" @click="chooseDateType(index, item)" v-for="(item, index) in timeChoose">
                {{ item.name }}
              </div>
            </div>
          </el-form-item>
          <div class="description-date" style="padding-left: 130px">
            <div v-if="dateTabIndex === 0">如：1977-01-01</div>
            <div v-if="dateTabIndex === 1">如：1977-01-01 23:59:59</div>
          </div>
          <el-form-item label="属性名称:" :label-width="addLabelWidth" style="padding: 20px 0 0 0" prop="name">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" prop="identity">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--地址-->
        <div v-if="addForm.type === 'addressPicker'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" style="padding: 10px 0 0 0" prop="name">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" :label-width="addLabelWidth" prop="identity">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
        </div>
        <!--单选-->
        <div v-if="addForm.type === 'radio'" :class="radioMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" prop="name">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" prop="identity" :label-width="addLabelWidth" style="padding: 0 0 20px 0;border-bottom: 1px solid #e5e5e5;margin-bottom: 0">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="radio-item" :key="index" v-for="(item, index) in addForm.radio" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="请输入选项" type="text" v-model="addForm.radio[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeRadioItem(index)">删除</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addRadioItem">增加可选项</div>
          </div>
        </div>
        <!--复选-->
        <div v-if="addForm.type === 'checkBox'" :class="checkBoxMore ? 'addMore' : 'normal'">
          <el-form-item label="属性名称:" :label-width="addLabelWidth" :rules="rules">
            <el-input class="stockInput" placeholder="输入属性名称" type="text" v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="字段标识:" prop="identity" :label-width="addLabelWidth" style="border-bottom: 1px solid #e5e5e5;padding-bottom: 10px;margin-bottom: 0">
            <el-input class="stockInput" placeholder="输入字段标识" type="text" v-model="addForm.identity" auto-complete="off"></el-input>
          </el-form-item>
          <div class="checkBox-item" :key="index" v-for="(item, index) in addForm.checkBox" style="border-bottom: 1px solid #e5e5e5;padding-top: 10px">
            <el-form-item :label="'选项' + (index + 1) + ':'" :label-width="addLabelWidth">
              <el-input class="stockInput" placeholder="输入选项" type="text" v-model="addForm.checkBox[index]" auto-complete="off"></el-input>
            </el-form-item>
            <div class="removeSelectItem" @click="removeCheckBoxItem(index)">删除</div>
          </div>
          <div>
            <div class="addSelectItem" @click="addCheckBoxItem">增加可选项</div>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: 10px">
        <el-button class="dialog-cancel-btn" @click="adddialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCustomerAttributeList, editCustomerAttribute, setCustomerAttributeIsNormal, addCustomerAttr, deleteCustomerAttr } from '@/api/customer.js'
export default {
  name: 'customerAttribute',
  data () {
    return {
      loading: true,
      isSystem: '',
      hide: false,
      productName: '',
      saleType: '',
      isOnSale: '',
      normal: [],
      notNormal: [],
      editdialog: false,
      area: '',
      currentPage: 1,
      limit: 15,
      totalCount: 0,
      page: 1,
      addLabelWidth: '80px',
      addForm: {
        name: '',
        score: '',
        type: 'input',
        identity: '',
        is_normal: 1,
        select: [''],
        checkBox: [''],
        option: [],
        radio: [''],
        dateType: ''
      },
      editForm: {
        name: '',
        score: '',
        type: 'input',
        identity: '',
        is_system: 1,
        option: [],
        select: [],
        checkBox: [],
        radio: [],
        dateType: ''
      },
      adddialog: false,
      checkBoxMore: false,
      radioMore: false,
      editMore: false,
      editCheckBoxMore: false,
      editRadioMore: false,
      editTypes: [
        {
          name: '文本',
          type: 'input'
        },
        {
          name: '下拉菜单',
          type: 'select'
        },
        {
          name: '时间',
          type: 'datePicker'
        },
        {
          name: '地址',
          type: 'addressPicker'
        },
        {
          name: '单选',
          type: 'radio'
        },
        {
          name: '复选',
          type: 'checkBox'
        }
      ],
      types: [
        {
          name: '文本',
          type: 'input'
        },
        {
          name: '下拉菜单',
          type: 'select'
        },
        {
          name: '时间',
          type: 'datePicker'
        },
        {
          name: '地址',
          type: 'addressPicker'
        },
        {
          name: '单选',
          type: 'radio'
        },
        {
          name: '复选',
          type: 'checkBox'
        }
      ],
      tabIndex: 0,
      editTabIndex: 0,
      addMore: false,
      timeChoose: [
        {
          name: '日期',
          dateType: 'datePicker'
        },
        {
          name: '日期和时间',
          dateType: 'dateTimePicker'
        }
      ],
      dateTabIndex: 0,
      editSystem: '',
      rules: {
        name: [
          { required: true, message: '请输入属性名称', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请输入字段标识', trigger: 'blur' }
        ],
        score: [
          { required: true, message: '请输入评分标准', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAddAttr()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 确认编辑属性
    confirmEditAttr() {
      if (this.editForm.type === 'input' || this.editForm.type === 'datePicker' || this.editForm.type === 'addressPicker' || this.editForm.type === 'dateTimePicker') {
        this.editForm.option = []
      } else if (this.editForm.type === 'select') {
        this.editForm.option = this.editForm.select
      } else if (this.editForm.type === 'radio') {
        this.editForm.option = this.editForm.radio
      } else if (this.editForm.type === 'checkBox') {
        this.editForm.option = this.editForm.checkBox
      }
      editCustomerAttribute(this.editForm.identity, this.editForm.name, this.editForm.score, this.editForm.option, this.editForm.is_system).then((res) => {
        if (res.data.code === 0) {
          this.editdialog = false
          this.getCustomerAttributeList()
          _g.toastMsg('success', '编辑成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 确认添加属性
    confirmAddAttr() {
      if (this.addForm.type === 'input' || this.addForm.type === 'datePicker' || this.addForm.type === 'addressPicker' || this.addForm.type === 'dateTimePicker') {
        this.addForm.option = []
      } else if (this.addForm.type === 'select') {
        this.addForm.option = this.addForm.select
      } else if (this.addForm.type === 'radio') {
        this.addForm.option = this.addForm.radio
      } else if (this.addForm.type === 'checkBox') {
        this.addForm.option = this.addForm.checkBox
      }
      addCustomerAttr(this.addForm.identity, this.addForm.name, this.addForm.score, this.addForm.type, this.addForm.option, this.addForm.is_normal).then((res) => {
        console.log(res)
        if (res.data.code === 0) {
          this.adddialog = false
          this.getCustomerAttributeList()
          _g.toastMsg('success', '添加成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 删除属性
    removeCustomerAttribute(item) {
      this.$confirm('确认删除该客户属性?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCustomerAttr(item.identity).then((res) => {
          if (res.data.code === 0) {
            this.getCustomerAttributeList()
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 删除添加checkBox可选项
    removeCheckBoxItem(index) {
      this.addForm.checkBox.splice(index, 1)
      if (this.addForm.checkBox.length === 1) {
        this.checkBoxMore = false
      }
    },
    // 删除编辑radio可选项
    removeEditRadioItem(index) {
      this.editForm.radio.splice(index, 1)
      if (this.editForm.radio.length === 1) {
        this.editRadioMore = false
      }
    },
    // 删除编辑checkBox可选项
    removeEditCheckBoxItem(index) {
      this.editForm.checkBox.splice(index, 1)
      if (this.editForm.checkBox.length === 1) {
        this.editCheckBoxMore = false
      }
    },
    // 增加添加checkBox可选项
    addCheckBoxItem() {
      this.addForm.checkBox.push('')
      this.checkBoxMore = true
    },
    // 增加编辑checkBox可选项
    addEditCheckBoxItem() {
      this.editForm.checkBox.push('')
      this.editCheckBoxMore = true
    },
    // 增加编辑radio可选项
    addEditRadioItem() {
      this.editForm.radio.push('')
      this.editRadioMore = true
    },
    // 选择时间类型
    chooseDateType(index, item) {
      this.dateTabIndex = index
      this.addForm.type = item.dateType
    },
    // 删除添加select可选项
    removeSelectItem(index) {
      this.addForm.select.splice(index, 1)
      if (this.addForm.select.length === 1) {
        this.addMore = false
      }
    },
    // 删除添加radio可选项
    removeRadioItem(index) {
      this.addForm.radio.splice(index, 1)
      if (this.addForm.radio.length === 1) {
        this.radioMore = false
      }
    },
    // 删除编辑select可选项
    removeEditSelectItem(index) {
      this.editForm.select.splice(index, 1)
      if (this.editForm.select.length === 1) {
        this.editMore = false
      }
    },
    // 增加添加select可选项
    addSelectItem() {
      this.addForm.select.push('')
      this.addMore = true
    },
    // 增加编辑select可选项
    addEditSelectItem() {
      this.editForm.select.push('')
      this.editMore = true
    },
    // 增加添加radio可选项
    addRadioItem() {
      this.addForm.radio.push('')
      this.radioMore = true
    },
    // 选择属性类型
    chooseType(index, item) {
      this.tabIndex = index
      this.addForm.type = item.type
    },
    // 添加属性
    addAttr() {
      this.adddialog = true
      this.addMore = false
      // 清空弹窗内容
      this.addForm.name = ''
      this.addForm.score = ''
      this.addForm.type = 'input'
      this.tabIndex = 0
      this.addForm.identity = ''
      this.addForm.is_normal = 1
      this.addForm.select = ['']
      this.addForm.checkBox = ['']
      this.addForm.radio = ['']
    },
    getCustomerAttributeList() {
      this.loading = true
      getCustomerAttributeList(this.page).then((res) => {
        if (res.data.code === 0) {
          let normal = []
          let notNormal = []
          for (let attr of res.data.data) {
            if (attr.is_normal === 0) {
              notNormal.push(attr)
            } else {
              normal.push(attr)
            }
          }
          this.normal = normal
          this.notNormal = notNormal
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 打开编辑弹窗
    openDialog(item) {
      this.editdialog = true
      this.editSystem = item.is_system
      this.editForm.type = item.type
      this.editForm.name = item.name
      this.editForm.score = item.score
      this.editForm.identity = item.identity
      this.editForm.is_system = item.is_system
      if (item.is_system === 0) {
        this.isSystem = false
      } else {
        this.isSystem = true
      }
      let arr = item.option
      if (item.type === 'input') {
        this.editTabIndex = 0
      } else if (item.type === 'select') {
        this.editTabIndex = 1
        this.editForm.select = arr
      } else if (item.type === 'datePicker' || item.type === 'dateTimePicker') {
        this.editTabIndex = 2
        if (item.type === 'datePicker') {
          this.dateTabIndex = 0
        } else if (item.type === 'dateTimePicker') {
          this.dateTabIndex = 1
        }
      } else if (item.type === 'addressPicker') {
        this.editTabIndex = 3
      } else if (item.type === 'radio') {
        this.editTabIndex = 4
        this.editForm.radio = arr
        console.log(this.editForm.radio)
      } else if (item.type === 'checkBox') {
        this.editTabIndex = 5
        this.editForm.checkBox = arr
      }
    },
    setCustomerAttribute(key, isNormal) {
      setCustomerAttributeIsNormal(key.identity, isNormal).then((res) => {
        if (res.data.code === 0) {
          this.getCustomerAttributeList()
          _g.toastMsg('success', '设置成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    }
  },
  created() {
    this.hide = true
    this.getCustomerAttributeList()
  }
}
</script>

<style scoped>
.description-date{
  width: 76%;
  color: #39C6CD;
  padding-left: 24%;
  text-align: left;
}
.text-align-left{
  text-align: left;
}
.date-type{
  width: 203px;
  display: flex;
  justify-content: space-between;
}
.date-type .dateChoose{
  border: 1px solid #39C6CD!important;
  color: #39C6CD!important;
}
.date-type div{
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #666;
  border: 1px solid #e5e5e5;
  cursor: pointer;
}
.date-type div:first-child{
  border-right: none;
}
::-webkit-scrollbar
{
  width: 6px;  /*滚动条宽度*/
  height: 16px;  /*滚动条高度*/
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 10px;  /*滚动条的背景区域的圆角*/
  background-color: #f5f5f5;/*滚动条的背景颜色*/
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
  border-radius: 10px;  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ccc;  /*滚动条的背景颜色*/
}
.addSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: #39C6CD;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.removeSelectItem{
  width: 90%;
  height: 30px;
  line-height: 30px;
  color: red;
  text-align: right;
  cursor: pointer;
  padding-right: 10%;
}
.addMore{
  height: 300px;
  overflow: auto;
}
.normal{
  height: auto;
  overflow: hidden;
}
.tabs{
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
}
.tabs div{
  width: 82px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #666;
  border:1px solid #e5e5e5;
  border-left: none;
  cursor: pointer;
}
.tabs div:first-child{
  border: 1px solid #e5e5e5;
}
.tabs .type-select{
  border:1px solid #39C6CD!important;
  color: #39C6CD;
}
.tabs .edit-type-select{
  border:1px solid #39C6CD!important;
  color: #39C6CD;
  background: #ccc!important;
}
.addAttr{
  display: block;
  padding: 0 15px;
  height: 30px;
  background: #4882ff;
  color: #fff;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  border-radius: 15px;
  float: right;
  margin-top: 5px;
  cursor: pointer;
}
.base-input {
  margin-top: 10px;
}
/*修改列表页input输入框*/
.base-input .el-input__inner {
  width: 180px!important;
  height: 36px!important;
}
.base-input .el-input{
  width: 180px!important;
}
.base-input .search-list-nav-select{
  width: 180px;
}
.base-input .search-list-nav{
  padding-bottom: 0;
  padding-top: 0;
}
.data-list-nav{
  padding-top: 10px;
  height: 38px;
}
/*搜索框*/
.el-icon-search {
  font-family: element-icons!important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased
}
.search-content {
  padding:10px;
  background: #fff;
  border: 1px solid #ebebeb;
  text-align: left;
}
.search-content span {padding-left: 10px;}
a.op-link{color:#4882ff;font-size: 14px}
.text-align-right{
  text-align: right
}
.table-foot {
  background: #fff;
  padding:10px;
  height:40px;
}
.table-foot-pagination {
  float: right;
}
.table-foot-pagination .el-input__inner {
  width: 100px !important;
}

/*表格数据居中*/
.el-table th>.cell, .el-table .cell{text-align: center}
.order-list-search-span {
  /*display: block;*/
  /*float: left;*/
}
.search-content-row {
  margin-top: 20px;
  text-align: left;
}
.table-foot-pagination{
  float: right;
}
.table-foot-pagination .el-pagination{
  margin-bottom: 10px;
  margin-right: 40px;
}
.customer-procuct-table {
  margin-top: 0px;
}
</style>
